import "../theme/AdministracionCatalogo.css";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import { TableAdministracionMarcaATB } from "../components/TableAdministracionMarcaATB";
import { authProvider } from "../context/authProvider";
import { BtnGoBack } from "../components/Buttons/BtnGoBack";

export const AdminPageMarcaATB = () => {
  return (
    <AzureAD provider={authProvider}>
      {({ authenticationState, accountInfo }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div className="body-color-admin">
              <div className="title-name-admin">
                <BtnGoBack caption="Volver a administración" />
              </div>
              <TableAdministracionMarcaATB />
            </div>
          );
        }
      }}
    </AzureAD>
  );
};
